import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-full font-bold transition-all duration-300 disabled:opacity-50 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        primary:
          "bg-gradient-to-l from-emerald-500 to-emerald-600 text-white shadow-lg shadow-emerald-600/30 hover:from-emerald-400 hover:to-emerald-500 hover:shadow-xl hover:shadow-emerald-500/40 hover:-translate-y-0.5 active:translate-y-0",

        lime:
          "bg-floodlight text-ink shadow-lime hover:bg-floodlight-300 hover:-translate-y-0.5 active:translate-y-0",

        navy:
          "bg-ink text-white shadow-lg shadow-ink/25 hover:bg-ink-800 hover:-translate-y-0.5",

        outline:
          "border border-white/30 bg-white/5 text-white backdrop-blur-md hover:bg-white/15 hover:border-white/60",

        outlineDark:
          "border border-slate-200 bg-white/70 text-ink backdrop-blur-md hover:border-emerald-400 hover:bg-white hover:text-emerald-700 hover:-translate-y-0.5",

        ghost:
          "text-slate-700 hover:bg-white/70",

        white:
          "bg-white text-ink shadow-md hover:bg-floodlight hover:-translate-y-0.5",

        link:
          "text-emerald-600 underline-offset-4 hover:underline",
      },

      size: {
        sm: "h-9 px-4 text-xs",
        md: "h-11 px-6 text-sm",
        lg: "h-12 px-8 text-base",
        icon: "h-10 w-10",
      },
    },

    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

export default function Button({
  as: Component = "button",
  variant,
  size,
  className,
  ...props
}) {
  return (
    <Component
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}

